/* unplugin-vue-components disabled */import { render } from "./PayBalance.vue?vue&type=template&id=6a23a1a0"
import script from "./PayBalance.vue?vue&type=script&lang=js"
export * from "./PayBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__